export enum TypeSalesSupportActions {
  MAIL_REMINDER_AUTO = 'MAIL_REMINDER_AUTO',
  MAIL_REMINDER = 'MAIL_REMINDER',
  PHONE_REMINDER = 'PHONE_REMINDER',
  COMMENTARY = 'COMMENTARY',
  CLOSE = 'CLOSE',
}
